import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=24f9aced"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports